import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { Alert, Button, Card, Form, Input, Select, DatePicker } from "antd";
import { useState } from "react";
import { useDispatch } from "react-redux";
import dayjs from "dayjs";

// 👉 Replace with your notification slice action
import { createNotification } from "../../store/slices/notificationSlice";

const { Option } = Select;
const { TextArea } = Input;

const AddNotification = () => {
    const [form] = Form.useForm();
    const dispatch = useDispatch();

    const [alertMessage, setAlertMessage] = useState("");
    const [alertType, setAlertType] = useState("success");
    const [buttonLoading, setButtonLoading] = useState(false);

    const onSubmit = async (values) => {
        setButtonLoading(true);

        try {
            const payload = {
                title: values.title,
                message: values.message,
                target_audience: values.target_audience,
                scheduled_at: values.scheduled_at
                    ? dayjs(values.scheduled_at).toISOString()
                    : null
            };

            const resultAction = await dispatch(createNotification(payload));

            if (createNotification.fulfilled.match(resultAction)) {
                setAlertMessage(
                    resultAction?.payload?.message || "Notification sent successfully"
                );
                setAlertType("success");
                form.resetFields();

                setTimeout(() => setAlertMessage(""), 4000);
            } else {
                setAlertMessage(
                    resultAction?.payload?.error || "Error sending notification"
                );
                setAlertType("error");
            }
        } catch (error) {
            setAlertMessage("Something went wrong");
            setAlertType("error");
        } finally {
            setButtonLoading(false);
        }
    };

    return (
        <div>
            <h1 style={{ marginBottom: 24 }}>Notification</h1>

            <Card title="Create Notification">
                {alertMessage && (
                    <Alert
                        message={alertMessage}
                        type={alertType}
                        showIcon
                        icon={
                            alertType === "success"
                                ? <CheckCircleOutlined />
                                : <CloseCircleOutlined />
                        }
                        closable
                        onClose={() => setAlertMessage("")}
                        style={{ marginBottom: 24 }}
                    />
                )}

                <Form layout="vertical" onFinish={onSubmit} form={form}>
                    
                    {/* Title */}
                    <Form.Item
                        label="Title"
                        name="title"
                        rules={[{ required: true, message: "Please enter title" }]}
                    >
                        <Input placeholder="Enter notification title" />
                    </Form.Item>

                    {/* Message */}
                    <Form.Item
                        label="Message"
                        name="message"
                        rules={[{ required: true, message: "Please enter message" }]}
                    >
                        <TextArea rows={4} placeholder="Enter notification message" />
                    </Form.Item>

                    {/* Target Audience */}
                    <Form.Item
                        label="Target Audience"
                        name="target_audience"
                        rules={[{ required: true, message: "Select audience" }]}
                    >
                        <Select placeholder="Select audience">
                            <Option value="agents">Agents</Option>
                            <Option value="customers">Customers</Option>
                            <Option value="b2busers">B2B Users</Option>
                        </Select>
                    </Form.Item>

                    {/* Schedule */}
                    <Form.Item
                        label="Schedule (Optional)"
                        name="scheduled_at"
                    >
                        <DatePicker
                            showTime
                            style={{ width: "100%" }}
                            placeholder="Select date & time"
                        />
                    </Form.Item>

                    {/* Submit */}
                    <Form.Item>
                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={buttonLoading}
                        >
                            Send Notification
                        </Button>
                    </Form.Item>
                </Form>
            </Card>
        </div>
    );
};

export default AddNotification;